// Fixes the button display bug when the page is loaded
document.addEventListener('DOMContentLoaded', () => {
    if (themeObject.filterBtn) {
        themeObject.filterBtn.classList.replace('hide', 'show');
    }
});
